import React, { useId } from 'react';

// NovaBotX product mark: a chat bubble on a brand gradient with the Novalink orbit ring.
// `withWordmark` adds the "NovaBotX" name beside the mark.
export default function NovaBotXLogo({ size = 36, withWordmark = false, tagline, className = '' }) {
  const id = useId().replace(/:/g, '');
  return (
    <span className={`nbx-logo ${className}`.trim()}>
      <svg
        className="nbx-logo-mark"
        width={size}
        height={size}
        viewBox="0 0 48 48"
        role="img"
        aria-label="NovaBotX"
      >
        <defs>
          <linearGradient id={`${id}-bg`} x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stopColor="#0b8cd6" />
            <stop offset="55%" stopColor="#19a7a0" />
            <stop offset="100%" stopColor="#4cb648" />
          </linearGradient>
          <linearGradient id={`${id}-ring`} x1="0" y1="0" x2="1" y2="0">
            <stop offset="0%" stopColor="#c9f0c4" />
            <stop offset="100%" stopColor="#ffffff" />
          </linearGradient>
        </defs>
        <rect x="1" y="1" width="46" height="46" rx="14" fill={`url(#${id}-bg)`} />
        {/* chat bubble */}
        <path
          d="M14 15.5h20a4.5 4.5 0 0 1 4.5 4.5v9a4.5 4.5 0 0 1-4.5 4.5h-9.2l-6.3 4.6c-.7.5-1.6 0-1.6-.8v-3.8H14A4.5 4.5 0 0 1 9.5 29v-9A4.5 4.5 0 0 1 14 15.5Z"
          fill="#fff"
        />
        <circle cx="18.5" cy="24.5" r="2.1" fill="#0b8cd6" />
        <circle cx="24" cy="24.5" r="2.1" fill="#19a7a0" />
        <circle cx="29.5" cy="24.5" r="2.1" fill="#4cb648" />
        {/* Novalink-style orbit */}
        <ellipse
          cx="24" cy="24.5" rx="21" ry="7.5"
          transform="rotate(-18 24 24.5)"
          fill="none"
          stroke={`url(#${id}-ring)`}
          strokeWidth="1.6"
          strokeDasharray="34 6 70 200"
          opacity="0.85"
        />
        <path d="M38.5 9.5l1 2.2 2.2 1-2.2 1-1 2.2-1-2.2-2.2-1 2.2-1z" fill="#fff" />
      </svg>
      {withWordmark && (
        <span className="nbx-logo-text">
          <span className="nbx-logo-name">NovaBot<span className="nbx-logo-x">X</span></span>
          {tagline && <span className="nbx-logo-tagline">{tagline}</span>}
        </span>
      )}
    </span>
  );
}
